import Icons from "../../components/icons";
import { Link } from "react-router-dom";
import { Fragment } from "react";
import styles from './style.module.css';

const Breadcrumbs = ({ urls }) => {
    return (
        <div className={styles.breadcrumbs}>
            <div className={(styles.crumbs) + ' ' + (styles.home)}><Link to='/'><Icons.HomeIcon /></Link></div>
            <div className={styles.step}><Icons.CrumbsRightIcon /></div>
            {urls.map((item, i) => {
                return (
                    <Fragment key={i}>
                        <div key={i} className={styles.crumbs + (item.path ? ' ' : ' ' + styles.active)}><Link to={item.path}>{item.title}</Link></div>
                        {i !== (urls.length-1) ? <><div key={i} className={styles.step}><Icons.CrumbsRightIcon /></div></> : ''}
                    </Fragment>
                )
            })}
        </div>
    );
}
export default Breadcrumbs;
